import concierge from './Concierge';
import altaModUsuario from './AltaModUsuario';
import asignarPerfilAUsuario from './AsignarPerfilAUsuario';
import configuracionSesionEditar from './ConfiguracionSesionEditar';
import configuracionSesionVista from './ConfiguracionSesionVista';
import editarPermisos from './EditarPermisos';
import listaDeUsuarios from './ListaDeUsuarios';
import perfilesyPermisos from './PerfilesyPermisos';
import permisosMasivos from './PermisosMasivos';
import permisosPorPerfil from './PermisosPorPerfil';
import usuariosPorPerfil from './UsuariosPorPerfil';
import vistaDeUsuario from './VistaDeUsuario';


export default {
    concierge,
    altaModUsuario,
    asignarPerfilAUsuario,
    configuracionSesionEditar,
    configuracionSesionVista,
    editarPermisos,
    listaDeUsuarios,
    perfilesyPermisos,
    permisosMasivos,
    permisosPorPerfil,
    usuariosPorPerfil,
    vistaDeUsuario,
};